/* unplugin-vue-components disabled */import { render } from "./popup-prize.vue?vue&type=template&id=412faf28&scoped=true"
import script from "./popup-prize.vue?vue&type=script&lang=js"
export * from "./popup-prize.vue?vue&type=script&lang=js"

import "./popup-prize.vue?vue&type=style&index=0&id=412faf28&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412faf28"]])

export default __exports__